import { TFunction } from 'i18next';
import { TeamViewTab } from 'modules/teams/domain/enums/team-view-tab';
import { Tab } from 'ud-ui/components/tabs/interfaces';

/**
 * Подписи и порядок вкладок карточки команды.
 *
 * Функция, а не константа: `t` доступна только во время рендера, и подписи,
 * посчитанные на импорте модуля, не пережили бы смену языка. Hash-и — в
 * `domain/enums/team-view-tab.ts`, они часть роута.
 */
export const getTeamViewTabs = (t: TFunction): Tab[] => [
  { hash: TeamViewTab.COMMON, label: t('teams.viewTabs.common') },
  { hash: TeamViewTab.PLAYERS, label: t('teams.viewTabs.players') },
  // Вкладка «Администраторы» (hash `admins`) была закомментирована до этой задачи.
  { hash: TeamViewTab.PARTICIPANTS, label: t('teams.viewTabs.participants') },
  { hash: TeamViewTab.WAITING_LIST, label: t('teams.viewTabs.waitingList') },
  { hash: TeamViewTab.KITS, label: t('teams.viewTabs.kits') },
];
